import styled from 'styled-components';
import { Boy, Flight, Male } from '@lt/components/icons-react';
import { Moon } from '@lt/components/icons-react/userflow';
import { CurrencyFormat } from '@lt/components';

export const Wrapper = styled.div`
  padding: 10px 8px 0;
  background: #fff;
  color: #4d4d4d;
  opacity: 0.95;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(210, 208, 197, 0.8);
  overflow: hidden;
`;

export const Link = styled.a`
  text-decoration: none;

  &:hover > * {
    color: #007aff;
  }
`;

export const Image = styled.div<{ src: string }>`
  height: 80px;
  background-size: cover;
  background-position: center;
  margin: -10px -8px 10px;
  ${({ src }) =>
    src &&
    `
  background-image: url(${src});
  `}
`;

export const Title = styled.h2`
  font-size: 22px;
  line-height: 26px;
  color: #17181a;
  margin-bottom: 4px;
  display: inline-block;
`;

export const Visa = styled.div<{ hasVisa: boolean }>`
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 8px;
  color: ${({ hasVisa }) => (hasVisa ? '#007AFF' : '#919499')};
`;

export const Adults = styled(Male)`
  width: 8px;
  height: 16px;
`;

export const Kids = styled(Boy)`
  width: 8px;
  height: 16px;

  ${Adults} + & {
    margin-left: 2px;
  }
`;

export const MoonIcon = styled(Moon)`
  width: 8px;
  height: 8px;
  margin-left: 2px;
  margin-bottom: -1px;
  width: 10px;
  height: 10px;
`;

export const FlightIcon = styled(Flight)`
  width: 16px;
  height: 16px;
  margin-bottom: -4px;
  margin-right: 3px;
`;

export const Price: typeof CurrencyFormat = styled(CurrencyFormat)`
  font-size: 22px;
  line-height: 26px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #17181a;
`;

export const SearchParams = styled.div`
  margin-bottom: 8px;
`;
